import { Color, ListFormValues } from './types';

export const COLORS: Color[] = ['primary', 'secondary', 'success', 'warning', 'info', 'error'];

export const DEFAULT_CREATE_PARAMS: ListFormValues = {
  color: 'primary',
  name: '',
  description: '',
  synced: true,
  public: false,
};
